import React, { useState } from 'react';

const card = {
  background: 'rgba(30,45,79,0.5)',
  borderRadius: '16px',
  border: '1px solid rgba(0,194,168,0.1)',
  padding: '24px',
};

function formatDate(ts) {
  if (!ts) return '—';
  return new Date(ts).toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' });
}

export default function ReportsList({ reports }) {
  const [expanded, setExpanded] = useState(null);

  return (
    <div style={card}>
      <div style={{ marginBottom:'20px' }}>
        <div style={{ fontFamily:'Space Grotesk', fontWeight:600, fontSize:'18px', color:'#F0F4FF' }}>Raw DMARC Reports</div>
        <div style={{ fontFamily:'Inter', fontSize:'13px', color:'#5B7BA8', marginTop:'4px' }}>
          {reports?.length || 0} reports parsed from Gmail
        </div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
        {(reports || []).map((report) => {
          const isOpen = expanded === report.reportId;
          const total = report.records.reduce((s, r) => s + r.count, 0);
          const pass = report.records.filter(r => r.dkimAligned === 'pass' || r.spfAligned === 'pass').reduce((s, r) => s + r.count, 0);
          const rate = total > 0 ? Math.round((pass / total) * 100) : 0;
          const color = rate >= 90 ? '#00C2A8' : rate >= 70 ? '#F5A623' : '#E8415A';

          return (
            <div key={report.reportId} style={{ borderRadius:'10px', border:'1px solid rgba(0,194,168,0.08)', overflow:'hidden' }}>
              <div
                onClick={() => setExpanded(isOpen ? null : report.reportId)}
                style={{
                  display:'flex', alignItems:'center', gap:'16px',
                  padding:'14px 16px', cursor:'pointer',
                  background: isOpen ? 'rgba(0,194,168,0.06)' : 'rgba(15,22,41,0.4)',
                  transition:'background 0.15s',
                }}>

                <div style={{ width:'6px', height:'36px', borderRadius:'3px', background:color, flexShrink:0 }} />

                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontFamily:'Space Grotesk', fontSize:'14px', fontWeight:500, color:'#F0F4FF' }}>
                    {report.orgName}
                  </div>
                  <div style={{ fontFamily:'JetBrains Mono', fontSize:'11px', color:'#5B7BA8', marginTop:'2px' }}>
                    {report.domain} · {formatDate(report.dateRange.begin)} – {formatDate(report.dateRange.end)}
                  </div>
                </div>

                <div style={{ textAlign:'right', flexShrink:0 }}>
                  <div style={{ fontFamily:'JetBrains Mono', fontSize:'13px', color:'#7B9CC8' }}>{total.toLocaleString()} msgs</div>
                  <div style={{ fontFamily:'Space Grotesk', fontSize:'13px', fontWeight:600, color, marginTop:'2px' }}>{rate}% pass</div>
                </div>

                <span style={{ color:'#5B7BA8', fontSize:'12px', transform: isOpen ? 'rotate(180deg)' : 'none', transition:'transform 0.2s' }}>▼</span>
              </div>

              {isOpen && (
                <div style={{ padding:'16px', background:'rgba(15,22,41,0.6)', borderTop:'1px solid rgba(0,194,168,0.08)' }}>
                  <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'12px', marginBottom:'16px' }}>
                    {[
                      { label:'Report ID', value:report.reportId },
                      { label:'Policy', value:`p=${report.policy?.p || 'none'}` },
                      { label:'DKIM Mode', value:`adkim=${report.policy?.adkim || 'r'}` },
                      { label:'SPF Mode', value:`aspf=${report.policy?.aspf || 'r'}` },
                      { label:'Coverage', value:`${report.policy?.pct || 100}%` },
                      { label:'Records', value:report.records.length },
                    ].map(item => (
                      <div key={item.label} style={{ background:'rgba(30,45,79,0.6)', borderRadius:'8px', padding:'10px 12px' }}>
                        <div style={{ fontFamily:'Inter', fontSize:'11px', color:'#5B7BA8', marginBottom:'4px' }}>{item.label}</div>
                        <div style={{ fontFamily:'JetBrains Mono', fontSize:'13px', color:'#F0F4FF' }}>{item.value}</div>
                      </div>
                    ))}
                  </div>

                  <div style={{ fontFamily:'Space Grotesk', fontSize:'13px', color:'#7B9CC8', marginBottom:'8px' }}>Records</div>
                  <div style={{ overflowX:'auto' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'12px' }}>
                      <thead>
                        <tr style={{ borderBottom:'1px solid rgba(0,194,168,0.1)' }}>
                          {['Source IP','Count','Disposition','DKIM','SPF','Header From'].map(h => (
                            <th key={h} style={{ padding:'6px 10px', textAlign:'left', fontFamily:'Space Grotesk', fontSize:'11px', color:'#5B7BA8', textTransform:'uppercase', letterSpacing:'0.5px', whiteSpace:'nowrap' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {report.records.map((rec, i) => (
                          <tr key={i} style={{ borderBottom:'1px solid rgba(30,45,79,0.8)' }}>
                            <td style={{ padding:'8px 10px', fontFamily:'JetBrains Mono', fontSize:'12px', color:'#F0F4FF' }}>{rec.sourceIp}</td>
                            <td style={{ padding:'8px 10px', fontFamily:'JetBrains Mono', fontSize:'12px', color:'#7B9CC8', textAlign:'right' }}>{rec.count}</td>
                            <td style={{ padding:'8px 10px' }}>
                              <span style={{
                                fontFamily:'JetBrains Mono', fontSize:'11px',
                                color: rec.disposition === 'none' ? '#00C2A8' : rec.disposition === 'quarantine' ? '#F5A623' : '#E8415A',
                                background: rec.disposition === 'none' ? 'rgba(0,194,168,0.1)' : rec.disposition === 'quarantine' ? 'rgba(245,166,35,0.1)' : 'rgba(232,65,90,0.1)',
                                padding:'2px 6px', borderRadius:'3px',
                              }}>{rec.disposition}</span>
                            </td>
                            {['dkimAligned','spfAligned'].map(key => (
                              <td key={key} style={{ padding:'8px 10px' }}>
                                <span style={{ color: rec[key] === 'pass' ? '#00C2A8' : '#E8415A', fontFamily:'JetBrains Mono', fontSize:'12px' }}>
                                  {rec[key] === 'pass' ? '✓ pass' : '✗ fail'}
                                </span>
                              </td>
                            ))}
                            <td style={{ padding:'8px 10px', fontFamily:'JetBrains Mono', fontSize:'12px', color:'#5B7BA8' }}>{rec.headerFrom}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
